import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlTourismNewsListRequest } from "../models/service-models/tourismNews/TourismNewsListRequest";
import { mdlTourismNewsListResponse } from "../models/service-models/tourismNews/TourismNewsListResponse";
import { GetResponse } from "../utils/ApiClient";

module TourismNewsService {
    export async function List(
        pRequest: mdlTourismNewsListRequest
    ): Promise<mdlServiceResponse<mdlTourismNewsListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlTourismNewsListResponse>>(
            "rssFeed/list",
            pRequest
        );
    }
}

export { TourismNewsService }